import { FieldTitle } from '@components/FieldTitle/FieldTitle';
import { Ionicons } from '@expo/vector-icons';
import { SizableText, XStack, YStack, useTheme } from 'tamagui';

interface NavigationFieldProps {
  label?: string;
  placeholder?: string;
  value?: string;
  required?: boolean;
  onPress?: () => void;
}

export const NavigationField = ({
  label,
  placeholder,
  value,
  required = false,
  onPress,
}: NavigationFieldProps): React.ReactElement => {
  const theme = useTheme();
  const displayValue = value?.trim().length ? value : undefined;
  const displayText = displayValue ?? placeholder ?? '';
  const textColor = displayValue ? '$color' : '$secondary75';

  return (
    <YStack gap="$2">
      <FieldTitle label={label} required={required} />
      <XStack
        alignItems="center"
        justifyContent="space-between"
        paddingHorizontal="$4"
        paddingVertical="$3"
        backgroundColor="$tertiary50"
        borderRadius="$true"
        minHeight="$true"
        onPress={onPress}
        cursor={onPress ? 'pointer' : undefined}
        pressStyle={onPress ? { backgroundColor: '$tertiary75' } : undefined}
        hoverStyle={onPress ? { backgroundColor: '$tertiary75' } : undefined}
      >
        <SizableText color={textColor}>{displayText}</SizableText>
        <Ionicons name="chevron-forward" size={20} color={theme.color?.val} />
      </XStack>
    </YStack>
  );
};
